import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'

import {
    CompleteDataWithServicesPayloadT,
    InvoicesDownloadExcelPayloadT,
    InvoicesDownloadExcelResponseT,
    InvoicesGetListParamsT,
    InvoicesGetListResponseT,
    InvoicesGetListShortParamsT,
    InvoicesGetQuantityParamsT,
    InvoicesGetQuantityResponseT,
    InvoicesGetStatusesResponse,
    InvoicesInternationalGetListParamsT,
    InvoicesWithServicesDownloadExcelPayloadT,
    InvoicesWithServicesDownloadExcelResponseT,
    InvoicesWithServicesListResponseT,
    UpdateInvoicePayloadT,
    UplodaFilesResponseT,
    WithServicesListParamsT,
} from '../types/invoices.types'

export class InvoicesRepository {
    getList(
        params?: InvoicesGetListParamsT | InvoicesGetListShortParamsT
    ): Promise<AxiosResponse<InvoicesGetListResponseT>> {
        return http.get('/cabinet/api/v2/admin/logistics-info', { params })
    }

    getInvoiceStatuses(): Promise<AxiosResponse<InvoicesGetStatusesResponse>> {
        const params = {
            isActive: 1,
        }

        return http.get('/cabinet/api/ref-statuses', { params })
    }

    getListInternational(
        params: InvoicesInternationalGetListParamsT
    ): Promise<AxiosResponse<InvoicesGetListResponseT>> {
        return http.get('/cabinet/api/v2/admin/logistics-info', { params })
    }

    getQuantity(
        params?: InvoicesGetQuantityParamsT
    ): Promise<AxiosResponse<InvoicesGetQuantityResponseT>> {
        return http.get('/cabinet/api/v2/admin/logistics-info/quantity', { params })
    }

    updateInvoice(
        invoice_id: number,
        payload: UpdateInvoicePayloadT
    ): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/v2/logistics-info/${invoice_id}`, payload)
    }

    importCashSum(form_data: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData(`/cabinet/api/admin/invoices/import-cash-sum`, form_data)
    }

    importInvoices(form_data: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData(`/cabinet/api/admin/invoices/cancel-with-excel`, form_data)
    }

    importDeleteAdditional(form_data: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData(`/cabinet/api/v2/additional-service/destroy-by-import`, form_data)
    }

    importDeclaredPrice(form_data: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData(`/cabinet/api/admin/invoices/import-declared-price`, form_data)
    }

    withServicesList(
        params: WithServicesListParamsT
    ): Promise<AxiosResponse<InvoicesWithServicesListResponseT>> {
        return http.get('/cabinet/api/admin/invoices/with-additional-services', { params })
    }

    enterDataWithServices(
        invoice_id: number,
        additionalServices: CompleteDataWithServicesPayloadT[]
    ): Promise<AxiosResponse<void>> {
        return http.put(
            `/cabinet/api/admin/invoices/${invoice_id}/additional-service-values/complete`,
            additionalServices
        )
    }

    exportExcel(
        params: InvoicesDownloadExcelPayloadT
    ): Promise<AxiosResponse<InvoicesDownloadExcelResponseT>> {
        return http.get('/cabinet/api/admin/invoices/export', {
            responseType: 'blob',
            params: { ...params },
        })
    }

    exportKaspiReport(
        params: InvoicesDownloadExcelPayloadT
    ): Promise<AxiosResponse<InvoicesDownloadExcelResponseT>> {
        return http.get('/cabinet/api/admin/invoices/kaspi-export', {
            responseType: 'blob',
            params: { ...params },
        })
    }

    exportExcelWithServices(
        params: InvoicesWithServicesDownloadExcelPayloadT
    ): Promise<AxiosResponse<InvoicesWithServicesDownloadExcelResponseT>> {
        return http.get('/cabinet/api/admin/invoices/with-additional-services/export', {
            responseType: 'blob',
            params,
        })
    }

    deleteService(id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/cabinet/api/v2/additional-service/${id}`)
    }

    deleteFile(id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/cabinet/api/file/${id}`)
    }

    deleteStatus(id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/cabinet/api/order-statuses/${id}`)
    }

    uploadFiles(form_data: FormData): Promise<AxiosResponse<UplodaFilesResponseT>> {
        return http.postFormData('/cabinet/api/file/upload-files', form_data)
    }
}
